import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {Observable, Subscription} from "rxjs";
import {ChartSeries} from "../chart-series";
import {MeasureDataType} from "../../measure-data-type";
import {DateTimeUtil} from "../../../utils/date-time-util";

@Component({
    selector: "bi-summary-card",
    templateUrl: "./summary-card.component.html",
    styleUrls: ["./summary-card.component.scss"]
})
export class SummaryCardComponent implements OnInit, OnDestroy {

    /**
     * Listens for updates for series data
     */
    @Input() public seriesData: Observable<ChartSeries[]>;
    @Input() maxSeries: number = 1;
    @Input() title: string;

    public values: {name: string, value: string, secondary: boolean}[] = [];
    private subscription: Subscription;

    static nFormatter(num, digits) {
        const si = [
            {value: 1, symbol: ""},
            {value: 1E3, symbol: "K"},
            {value: 1E6, symbol: "M"},
            {value: 1E9, symbol: "B"},
            {value: 1E12, symbol: "T"}
        ];
        const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        let i;
        for (i = si.length - 1; i > 0; i--) {
            if (Math.abs(num) >= si[i].value) {
                break;
            }
        }
        return si[i].value === 1 ? num.toFixed(digits) : (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
    }

    ngOnInit(): void {
        this.subscription = this.seriesData.subscribe((seriesDataArr: ChartSeries[]) => {
            this.values = [];
            if (seriesDataArr) {
                seriesDataArr.slice(0, this.maxSeries).forEach((series: ChartSeries) => {
                    let total: number = 0;
                    if (series.data) {
                        series.data.forEach((n: number) => total = total + n);
                    }
                    let totalSt: string;
                    if (series.dataType === MeasureDataType.CURRENCY) {
                        totalSt = SummaryCardComponent.nFormatter(total, total >= 1E8 ? 0 : total >= 1E7 ? 1 : total >= 1E6 ? 2 : total >= 1E5 ? 0 : total >= 1E4 ? 1 : total >= 1E3 ? 2 : total >= 1E2 ? 0 : 2);
                        totalSt = "$" + totalSt;
                    } else if (series.dataType === MeasureDataType.PERCENTAGE) {
                        totalSt = SummaryCardComponent.nFormatter(total, 2);
                        totalSt = totalSt + " %";
                    } else if (series.dataType === MeasureDataType.CALCULATED_PERCENTAGE) {
                        totalSt = 100 + " %";
                    } else if (series.dataType === MeasureDataType.SECONDS) {
                        totalSt = DateTimeUtil.formatTimeForSeconds(total);
                    } else if (series.dataType === MeasureDataType.COUNT) {
                        totalSt = SummaryCardComponent.nFormatter(total, total >= 1E8 ? 0 : total >= 1E7 ? 1 : total >= 1E6 ? 2 : total >= 1E5 ? 0 : total >= 1E4 ? 1 : total >= 1E3 ? 2 : 0);
                    } else {
                        totalSt = SummaryCardComponent.nFormatter(total, 2);
                    }
                    this.values.push({name: series.name, value: totalSt, secondary: series.secondary});
                });
            }
        });
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
